import { render, staticRenderFns } from "./WikiCustomCss.vue?vue&type=template&id=47299fee"
import script from "./WikiCustomCss.vue?vue&type=script&lang=ts"
export * from "./WikiCustomCss.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports